import { render, staticRenderFns } from "./CopyLeaderBoardLinkModal.vue?vue&type=template&id=61206e4e"
import script from "./CopyLeaderBoardLinkModal.vue?vue&type=script&lang=js"
export * from "./CopyLeaderBoardLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports